import React from 'react'
import { Navigate } from 'react-router-dom'

import routePath from 'router/routePath'
import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

type MessagingGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

export const MessagingGate: React.FC<MessagingGateProps> = ({
  children,
  redirectTo = routePath.notFound404,
}) => {
  const { messaging } = useModuleConfig()
  return messaging ? children : <Navigate to={redirectTo} replace />
}
